import { jsx as C } from "react/jsx-runtime";
const r = ({ width: o = 20, height: n = 16 }) => /* @__PURE__ */ C(
  "svg",
  {
    width: o,
    height: n,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "coupon-icon",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M1.5 16C1.1 16 0.75 15.85 0.45 15.55C0.15 15.25 0 14.9 0 14.5V10.675C0.616667 10.5417 1.12917 10.2208 1.5375 9.7125C1.94583 9.20417 2.15 8.63333 2.15 8C2.15 7.36667 1.94583 6.79167 1.5375 6.275C1.12917 5.75833 0.616667 5.44167 0 5.325V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H18.5C18.9 0 19.25 0.15 19.55 0.45C19.85 0.75 20 1.1 20 1.5V5.325C19.3833 5.44167 18.875 5.75833 18.475 6.275C18.075 6.79167 17.875 7.36667 17.875 8C17.875 8.63333 18.075 9.20417 18.475 9.7125C18.875 10.2208 19.3833 10.5417 20 10.675V14.5C20 14.9 19.85 15.25 19.55 15.55C19.25 15.85 18.9 16 18.5 16H1.5ZM1.5 14.5H18.5V11.775C17.9 11.3583 17.3958 10.8208 16.9875 10.1625C16.5792 9.50417 16.375 8.78333 16.375 8C16.375 7.21667 16.5792 6.49583 16.9875 5.8375C17.3958 5.17917 17.9 4.64167 18.5 4.225V1.5H1.5V4.225C2.1 4.64167 2.60833 5.17917 3.025 5.8375C3.44167 6.49583 3.65 7.21667 3.65 8C3.65 8.78333 3.44167 9.50417 3.025 10.1625C2.60833 10.8208 2.1 11.3583 1.5 11.775V14.5ZM7.4 12.05L10 10.025L12.6 12.05L11.6 8.85L14.05 6.8H11.05L10 3.75L8.95 6.8H5.95L8.4 8.85L7.4 12.05Z",
        fill: "var(--color-main)"
      }
    )
  }
);
export {
  r as CouponIcon
};
